module.exports = __webpack_public_path__ + "img/horizontal_1_1_8019.91dbdcd9.png";